import { MemberModel } from "@app/models/system/member.model";
import { ValidationUtil } from "./validation.util";
import { ConvertUtil } from "./convert.util";
import { MemberConstants } from "../constant/member.constant";

export class AuthUtil {
  static readonly TIME_MIN_EXPIRED = 90 * 60 * 1000;

  static actionLogOut(){
    localStorage.removeItem('member');
    localStorage.removeItem('lastAction');
  }
  static isSessionExpired(): boolean {
    let lastAction = localStorage.getItem('lastAction');
    if(lastAction){
      const now = Date.now();
      const timeLeft = parseInt(lastAction) + AuthUtil.TIME_MIN_EXPIRED;
      const diff = timeLeft - now;
      return diff <= 0;
    }else{
      return true
    }
  }

  static getLoginedInfo(): MemberModel | null {
    let str = localStorage.getItem("member");
    if (ValidationUtil.isNotNullAndNotEmpty(str)) {
      return JSON.parse(str + "");
    }
    return null;
  }

  static isLogined(): boolean {
    return ValidationUtil.isNotNullAndNotEmpty(AuthUtil.getLoginedInfo());
  }

  static getUserId() : string {
    return ValidationUtil.isNotNullAndNotEmpty(AuthUtil.getLoginedInfo()) ? ConvertUtil.convertToString(AuthUtil.getLoginedInfo()?.userid) : "";
  }

  static rankCdNumber(): number {
    let rankCd = ValidationUtil.isNotNullAndNotEmpty(AuthUtil.getLoginedInfo()) ? ConvertUtil.convertToString(AuthUtil.getLoginedInfo()?.rankCd) : "";
    return ValidationUtil.isNotNullAndNotEmpty(rankCd) ? Number(rankCd.substring(2,4)) : 0;
  }


  static checkPermissionLevel_1(): boolean {
    let rankCd = ValidationUtil.isNotNullAndNotEmpty(AuthUtil.getLoginedInfo()) ? ConvertUtil.convertToString(AuthUtil.getLoginedInfo()?.rankCd) : "";
    let numRank = ValidationUtil.isNotNullAndNotEmpty(rankCd) ? Number(rankCd.substring(2,4)) : 0;

    if(numRank >= MemberConstants.PERMISSION_MEMBER){
      return true;
    }
    return false;
  }

  static checkPermissionLevel_2(): boolean {
    let rankCd = ValidationUtil.isNotNullAndNotEmpty(AuthUtil.getLoginedInfo()) ? ConvertUtil.convertToString(AuthUtil.getLoginedInfo()?.rankCd) : "";
    let numRank = ValidationUtil.isNotNullAndNotEmpty(rankCd) ? Number(rankCd.substring(2,4)) : 0;
    
    if(numRank >= MemberConstants.PERMISSION_AGENT){
      return true;
    }
    return false;
  }

   static checkPermissionViewMenuShippingOrder(): boolean {
    return (this.getUserId() === "0325120001" ||  
            this.getUserId() === "CRN000000"  || 
            this.getUserId() === "CRN230290"
          );
  }

   static checkPermissionView(): boolean {
    // return (this.getUserId() === "0325120001" || 
    //         this.getUserId() === "0325120002" || 
    //         this.getUserId() === "0325120003" 
    //       );
    return true;
  }

  static checkPermission(): number {
    let rankCd = ValidationUtil.isNotNullAndNotEmpty(AuthUtil.getLoginedInfo()) ? ConvertUtil.convertToString(AuthUtil.getLoginedInfo()?.rankCd) : "";
    let numRank = ValidationUtil.isNotNullAndNotEmpty(rankCd) ? Number(rankCd.substring(2,4)) : 0;

    if (numRank == MemberConstants.PERMISSION_MEMBERS) {
      return 1;
    }else if (numRank == MemberConstants.PERMISSION_MASTER_AGENT) {
      return 2;
    }else if (numRank >= MemberConstants.PERMISSION_DISTRIBUTOR) {
      return 3;
    }
    return 0;
  }

}
